/* eslint-disable import/no-unused-modules */

import { useContext } from "react";
import { MobXProviderContext, useObserver } from "mobx-react";

import { mapValuationDataToViewFields } from "../../utilities/mapValuationDataToViewFields";

export const useStore = () => useContext(MobXProviderContext);

export const useUIStoreData = () => {
  const { store } = useStore();
  const { uiStore } = store;

  return useObserver(() => ({
    contentView: uiStore.contentView,
    modalView: uiStore.modalView,
    isModalOpen: uiStore.isModalOpen,
    sellerInquiryType: uiStore.sellerInquiryType,
    isSellerInquiryModalOpen: uiStore.isSellerInquiryModalOpen,
    showMinimalComponentTreatment: uiStore.showMinimalComponentTreatment
  }));
};

export const useValuationStoreData = () => {
  const { store } = useStore();
  const { valuationStore } = store;

  return useObserver(() => ({
    propertyId: valuationStore.propertyId,
    ...mapValuationDataToViewFields(valuationStore.valuationData)
  }));
};

export const useUserStoreData = () => {
  const { store } = useStore();
  const { userDataStore } = store;

  return useObserver(() => ({
    email: userDataStore.email,
    name: userDataStore.name,
    phoneNumber: userDataStore.phoneNumber
  }));
};

export const useValidationStoreData = () => {
  const { store } = useStore();
  const { validationStore } = store;

  return useObserver(() => ({
    predefinedOptions: validationStore.ownerNameOptions
  }));
};
